import { render, staticRenderFns } from "./OutlineResources.vue?vue&type=template&id=b8568ee0&"
import script from "./OutlineResources.vue?vue&type=script&lang=js&"
export * from "./OutlineResources.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports